<div class="container-fluid">
    <div class="row" *ngFor="let item of items; index as i">
        <div class="col d-flex align-items-center mb-1">
            <app-svg-icon *ngIf="item.Checkpoint" [size]="16" icon="patch-check-fill" class="text-primary me-1">
            </app-svg-icon>
            <h3 class="mb-0 pe-1 mas-chico" [style.color]="colores[obtenerId(pregunta.Tipo)]"
                [attr.item-id]="(!accesoPublico ? item.Id : null)"
                ngbTooltip="{{(!accesoPublico ? item.Id : null)}}" container="body">
                {{ item.IdRelativo }}
            </h3>
            <textarea rows="1" type="text" class="form-control white-borders no-resize" [(ngModel)]="item.Texto"
                      [disabled]="accesoPublico">
            </textarea>
        </div>
        <div class="col-3">
            <ng-select [items]="preguntas" bindLabel="texto" bindValue="id" [clearable]="false"
                [(ngModel)]="item.PreguntaSiguiente" [compareWith]="compararId" [disabled]="accesoPublico">
            </ng-select>
        </div>
    </div>
    <div class="row" *ngIf="!accesoPublico">
        <div class="col flex-grow-0 h3 mb-0 pe-0">+</div>
        <div class="col mb-3">
            <input type="text" placeholder="Agregue una respuesta..." [(ngModel)]="textoItem"
            class="form-control no-borders" (keyup.enter)="agregarCmd.ejecutar()"
            [disabled]="!agregarCmd.puedeEjecutarse" />
        </div>
    </div>
</div>
